<template>
  <v-main>
    <AppBar extension-height="134">
      <div class="fill-width">
        <div class="date text-center">
          <!-- <v-btn plain icon :ripple="false" style="transform: rotate(180deg);" @click="prevWeek()" ><img :src="getImage('ic_arrow_right5.svg')"></v-btn>
          <span class="px-3">{{thisWeek}}</span>
          <v-btn plain icon :ripple="false" @click="nextWeek()" ><img :src="getImage('ic_arrow_right5.svg')"></v-btn> -->

          <v-btn plain icon :ripple="false" style="transform: rotate(180deg);" @click="prevDay()">
            <img :src="getImage('ic_arrow_right5.svg')">
          </v-btn>
          <span class="px-3">{{ thisDay }}</span>
          <v-btn plain icon :ripple="false" @click="nextDay()">
            <img :src="getImage('ic_arrow_right5.svg')">
          </v-btn>
        </div>
        <div class="week mt-3">
          <div v-for="i in weekData.length" :key="i" :class="weekData[i-1].todayYn == 'Y'? 'active today' : ''"
               @click="clickDay(i)">
            <span>{{ weekData[i - 1].dayOfWeek }}</span><span>{{ weekData[i - 1].day }}</span>
          </div>
          <!--
          <div class="active today"><span>수</span><span>25</span></div>
          <div><span>토</span><span>25</span></div>
          -->
        </div>
        <hr class="hr flex-shrink-0 mx-n5 mt-5"/>
      </div>
    </AppBar>
    <v-layout fill-height column align-start>
      <!-- 데이타 없을 경우 -->
      <v-container fluid flex-fill                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              class="no-data" v-if="note1.length < 1 && note2.length < 1 && note3.length < 1">
        <div class="no-data-text">
          아직 작성해주신 마음노트가 없습니다.<br>
          작성해주세요.
        </div>
      </v-container>
      <v-container v-else fluid flex-fill class="pt-0">
        <div class="py-4" v-if="note1.length > 0">
          <div class="fs-20 fw-600 mb-4">오늘의 기억들</div>
          <!-- 이미지 -->
          <div v-if="note1[0].img !=''" class="mb-4">
            <v-img :src="$downUrl(note1[0].img)"></v-img>
          </div>
          <!-- 음성메모 -->
          <div v-if="note1[0].audio !=null" class="voice-note mb-5">
            <div>
              <div class="fw-600 lightBlack--text mb-2">음성 메모</div>
              <!-- <div class="fs-14 lightBlack--text">10:00</div> -->
            </div>
            <div>
              <v-btn icon class="btn-play" @click="control(1)">
                <Play :play="play"/>
              </v-btn>
            </div>
          </div>
          <div class="fs-14 lightBlack--text mb-10">{{ note1[0].reply }}</div>
        </div>
        <v-divider v-if="note2.length > 0" class="divider"></v-divider>
        <div v-if="note2.length > 0" class="py-4">
          <div class="fs-20 fw-600 mb-4">오늘의 감사일기</div>
          <div v-for="i in note2.length/2" :key="i" class="mb-10">
            <v-chip color="primary">{{ note2[(i - 1) * 2] }}</v-chip>
            <div class="fs-14 lightBlack--text">{{ note2[(i - 1) * 2 + 1] }}</div>
          </div>
        </div>
        <v-divider v-if="note3.length > 0" class="divider"></v-divider>
        <div v-if="note3.length > 0" class="py-4">
          <div class="fs-20 fw-600 mb-4">나를 위한 생각과 다짐</div>
          <!-- 이미지 -->
          <div class="mb-4">
            <v-img :src="$downUrl(note3[0].img)"></v-img>
          </div>
          <!-- 음성메모 -->
          <div v-if="note3[0].audio !=null" class="voice-note mb-5">
            <div>
              <div class="fw-600 lightBlack--text mb-2">음성 메모</div>
              <!-- <div class="fs-14 lightBlack--text">10:00</div> -->
            </div>
            <div>
              <v-btn icon class="btn-play" @click="control(2)">
                <Play :play="play2"/>
              </v-btn>
            </div>
          </div>
          <div class="fs-14 lightBlack--text mb-10">{{ note3[0].reply }}</div>
        </div>
      </v-container>
    </v-layout>

  </v-main>
</template>

<script>
import Play from '@/components/icons/Play2'
import moment from 'moment'
import store from '../../store'

export default {
  data: () => ({
    play: true,
    play2: true,
    today: '',
    thisWeek: '',
    thisDay: '',
    startDt: '',
    endDt: '',
    weekData: [],
    note1: [],
    note2: [],
    note3: [],
    audio1: '',
    audio2: '',
    initDay:'',
  }),
  components: {
    Play,
  },
  watch: {
    today() {
      console.log("this.today : ",this.today)
      console.log("this.initDay : ",this.initDay)
      this.getWeekData(this.today)
    },
  },
  mounted() {
    this.getToday() // 오늘 날짜 구함
    // console.log("this.weekData : ",this.weekData)
  },
  methods: {
    async getUnitMindNoteReply() {

      // 초기화
      this.note1.splice(0, this.note1.length)
      this.note2.splice(0, this.note2.length)
      this.note3.splice(0, this.note3.length)

      await store.dispatch('getUnitMindNoteReply', this.$_payload('so', [{'userKey': this.$store.state.auth.authUser.userKey}
        , {'regDt': this.today.format('YYYYMMDD')}
      ]))
          .then(res => {
            if (res.success) {
              // console.log('res.data.length : ', res.data.length)

              if (res.data.length > 0) {

                res.data.forEach((obj, i) => {
                  // console.log('obj : ', obj)

                  if (i == 0) {
                    var note1Obj = {reply: '', img: '', audio: ''}

                    obj.replyList.forEach((reply) => {
                      if (reply.reply == '사진') {
                        note1Obj.img = reply.fileName
                      } else if (reply.reply == '녹음') {
                        note1Obj.audio = reply.fileName
                        if (note1Obj.audio != '' && note1Obj.audio != null) {
                          this.audio1 = new Audio(this.$downUrl(note1Obj.audio))
                        }
                      } else {
                        note1Obj.reply = reply.reply
                      }
                    })
                    console.log("note1Obj : ", note1Obj)
                    this.note1.push(note1Obj)

                  } else if (i == 1) {
                    obj.replyList.forEach((reply) => {
                      this.note2.push(reply.reply)
                    })

                  } else {
                    var note3Obj = {reply: '', img: '', audio: ''}

                    obj.replyList.forEach((reply) => {
                      if (reply.reply == '사진') {
                        note3Obj.img = reply.fileName
                      } else if (reply.reply == '녹음') {
                        note3Obj.audio = reply.fileName
                        if (note3Obj.audio != '' && note3Obj.audio != null) {
                          this.audio2 = new Audio(this.$downUrl(note3Obj.audio))
                          // console.log("this.audio1 : ",this.audio1)
                        }
                      } else {
                        note3Obj.reply = reply.reply
                      }
                    })
                    console.log("note3Obj : ", note3Obj)
                    this.note3.push(note3Obj)
                  }
                })
              }
              console.log('this.note1 : ', this.note1)
              console.log('this.note2 : ', this.note2)
              console.log('this.note3 : ', this.note3)

            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
            // this.answer = [];
          })
          .finally(() => {
          })
    },
    getToday() {
      const moment = require('moment')
      const today = moment()
      this.today = today
      this.initDay = today.format('YYYYMMDD')
    },
    getWeekData(today) {
      const moment = require('moment')

      const varToday = moment(today)

      this.thisDay = varToday.format('YYYY년 MM월 DD일')

      // 주차 시작/종료일 구하기
      const startDt = moment(this.today).day(0).format('YYYYMMDD')
      const endDt = moment(this.today).day(6).format('YYYYMMDD')
      this.startDt = startDt
      this.endDt = endDt

      // 초기화
      this.weekData.splice(0, this.weekData.length)

      const sd = moment(this.startDt)
      for (let i = 0; i < 7; i++) {

        var obj = {dayOfWeek: '', date: '', year: '', month: '', day: '', todayYn: 'N'}

        if (i != 0) {
          sd.add(1, "days")
        }

        // 요일
        if (sd.day() == 0) {
          obj.dayOfWeek = '일'
        } else if (sd.day() == 1) {
          obj.dayOfWeek = '월'
        } else if (sd.day() == 2) {
          obj.dayOfWeek = '화'
        } else if (sd.day() == 3) {
          obj.dayOfWeek = '수'
        } else if (sd.day() == 4) {
          obj.dayOfWeek = '목'
        } else if (sd.day() == 5) {
          obj.dayOfWeek = '금'
        } else if (sd.day() == 6) {
          obj.dayOfWeek = '토'
        }

        // console.log("today : ", varToday.format('YYYY-MM-DD'))
        // console.log("비교 : ", sd.isSame(varToday.format('YYYY-MM-DD')))

        // 선택날짜
        if (sd.isSame(varToday.format('YYYY-MM-DD'))) {
          obj.todayYn = 'Y'
        }
        // 날짜
        obj.date = sd.format('YYYYMMDD')
        obj.year = sd.format('YYYY')
        obj.month = sd.format('MM')
        obj.day = sd.format('DD')

        // console.log("sd요일 : ", sd.day())
        // console.log("sd : ", sd.format('D'))
        // console.log("obj : ", obj)

        this.weekData.push(obj)
      }
      // console.log("this.weekData : ", this.weekData)
      // console.log("주차 시작일 : ", this.startDt)
      // console.log("주차 종료일 : ",this.endDt)

      // 데이터 조회
      this.getUnitMindNoteReply()
    },
    prevDay () {
      this.init()
      const prevDt = moment(this.today)
      this.today = prevDt.subtract(1, "day")
    },
    nextDay () {
      const nextDt = moment(this.today)
      const nextEq = nextDt.add(1, 'day').format('YYYYMMDD')

      if(nextEq <= this.initDay ){
        this.init()
        this.today = nextDt
      }
    },
    clickDay (i) {
      if(this.weekData[i - 1].date <= this.initDay ){
        this.init()
        this.today = moment(this.weekData[i - 1].date)
      }
    },
    init() {
      console.log("this.audio1 : ", this.audio1)
      console.log("this.audio2 : ", this.audio2)

      this.play = true
      this.play2 = true

      if (this.audio1 != null && this.audio1 != '') {
        this.audio1.pause()
        this.audio1 = ''
      }

      if (this.audio2 != null && this.audio2 != '') {
        this.audio2.pause()
        this.audio2 = ''
      }
    },
    control(seq) {
      if (seq == 1) {
        this.play = !this.play;
        if (!this.play) {
          this.audioPlay(seq)
        } else {
          this.audioPause(seq)
        }

      } else {
        this.play2 = !this.play2;

        if (!this.play2) {
          this.audioPlay(seq)
        } else {
          this.audioPause(seq)
        }
      }
    },
    audioPlay(seq) {
      if (seq == 1) {
        this.audio1.play()
      } else {
        this.audio2.play()
      }
    },
    audioPause(seq) {
      if (seq == 1) {
        this.audio1.pause()
      } else {
        this.audio2.pause()
      }
    },
  },
  beforeDestroy() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
.date {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
}

.week {
  display: flex;
  justify-content: space-around;

  > div {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 7px;
    border-radius: 20px;

    span {
      font-size: 13px;
      color: #101010;

      &:nth-child(2) {
        font-weight: bold;
        margin-top: 5px;
      }
    }

    &.active {
      background: #7260FF;

      span {
        color: #fff;
      }
    }

    &.today {
      &:after {
        content: '';
        color: #7260FF;
        position: absolute;
        bottom: -18px;
        font-size: 9px;
      }
    }
  }
}

::v-deep.v-chip {
  font-size: 13px;
  height: 22px;
  padding: 0 10px;
  margin-bottom: 10px;
}

.voice-note {
  position: relative;
  height: 90px;
  border: 1px solid #E6E8EA;
  border-radius: $border-radius-root;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 30px 20px 20px;
}
</style>
